import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const ProcesosPOC = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/proceso-POC.pdf`;
  /*const pdfUrl = "/pdf/proceso-POC.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Procesos POC - Diagrama</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Procesos POC - Diagrama" />
      </Container>
    </>
  );
};

 export default ProcesosPOC;
